var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"pd20",staticStyle:{"height":"calc(100vh - 60px)"}},[_c('div',{staticClass:"flex",staticStyle:{"height":"100%"}},[_c('div',{staticStyle:{"width":"35%","height":"100%"}},[_c('cash-register')],1),_c('div',{staticClass:"ml20",staticStyle:{"width":"60%","height":"100%"}},[_c('exhibition-area')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }